import { render, staticRenderFns } from "./ShiftsWidget.vue?vue&type=template&id=b597d540&scoped=true&"
import script from "./ShiftsWidget.vue?vue&type=script&lang=js&"
export * from "./ShiftsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsWidget.vue?vue&type=style&index=0&id=b597d540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b597d540",
  null
  
)

export default component.exports